import React from "react";
import { MultiSelect } from "react-multi-select-component";
import SectionHeading from "../../components/SectionHeading";
import OrganizationLogo from "../../components/OrganizationLogo";
import close from "../../assets/icons/close-icon.svg";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

function RelatedOrganization({
    relatedOrganizations,
    selectedRelatedOrganizations,
    handleRelatedOrganizations,
    selectedOrganization,
    removeOrgPreference,

    organizationPreference,
}) {
    function handleSelect(organization) {
        handleRelatedOrganizations(organization);
    }
    
    // Refactored nested ternary into clear conditional logic
    function getClassName() {
        const selectedCount = selectedRelatedOrganizations.length;
        const hasPartialSelection = selectedCount >= 1 && selectedCount !== relatedOrganizations.length;
        
        if (!hasPartialSelection) {
            return ",";
        }
        
        if (selectedCount >= 1 && selectedCount < 7) {
            return "test";
        }
        
        return "modify";
    }
    
    const className = getClassName();

    const {totalParentOrganizations} = useSelector(
        (state) => state.organizations
    );

    const hasOrganizationPreference = Array.isArray(organizationPreference)
        ? organizationPreference.length > 0
        : Boolean(organizationPreference);

    const hasSelectedRelatedOrganizations =
        selectedRelatedOrganizations.length > 0;

    const shouldShowRemovePreferenceIcon =
        totalParentOrganizations !== 1 &&
        (hasOrganizationPreference || hasSelectedRelatedOrganizations);

    return (
        <div className="row  mx-0">
            <OrganizationLogo
                organizationName={selectedOrganization?.ORGNIZATIONNAME}
                label={true}
                height={55.01}
            />
            <div
                className="section-card mb-20p col "
                style={{ backgroundColor: "#E6EEF4", padding: 24, width: 300 }}
            >
                <div className="d-flex">
                    <SectionHeading
                        heading={selectedOrganization?.ORGANIZATIONGROUPNAME}
                        tabIndex="0"
                    />
                    {shouldShowRemovePreferenceIcon && (
                        <button
                            type="button"
                            className="ms-2 align-self-start p-0 border-0 bg-transparent"
                            onClick={removeOrgPreference}
                            aria-label="Remove organization preference"
                        >
                            <img
                                className="closeicon"
                                src={close}
                                alt=""
                                width="25px"
                            />
                        </button>
                    )}
                </div>

                <>
                    <label>Related organizations</label>

                    <div>
                        <MultiSelect
                            className={"select-dropdown " + className}
                            options={relatedOrganizations}
                            value={selectedRelatedOrganizations}
                            onChange={handleSelect}
                            labelledBy="Select"
                            disableSearch={false}
                            isCreatable={false}
                            overrideStrings={{
                                selectSomeItems: "Add related Organization +",
                            }}
                        />
                    </div>
                </>
            </div>
        </div>
    );
}

RelatedOrganization.propTypes = {
    relatedOrganizations: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.any.isRequired,
        })
    ).isRequired,
    selectedRelatedOrganizations: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.any.isRequired,
        })
    ).isRequired,
    handleRelatedOrganizations: PropTypes.func.isRequired,
    selectedOrganization: PropTypes.shape({
        ORGNIZATIONNAME: PropTypes.string,
        ORGANIZATIONGROUPNAME: PropTypes.string,
    }),
    removeOrgPreference: PropTypes.func.isRequired,
    organizationPreference: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.number,
    ]),
};

export default React.memo(RelatedOrganization);
